<script>
export default {
  name: 'vectorLayer',
  data() {
    
  },
}
</script>


// WEBPACK FOOTER //
// src/components/map/VectorLayer.vue